import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");
// const API_URL = 'http://localhost:8083'


export default {
  getAllEmails: async () => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/email/templates`)
    return response
  },
  getDetailEmail: async (id) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/email/templates/${id}`)
    return response
  },
  addEmail: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/email/templates`, {
      method: 'POST',
      data
    })
    return response;
  },
  editEmail: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/email/templates/${data.id}`, {
      method: 'PUT',
      data
    })
    return response;
  },
}